export const getEnvVar = (key: string): string | undefined => {
  return window.runtimeEnv?.[key] ?? (import.meta.env[key] as string | undefined);
};
